import PropTypes from "prop-types";

import InfoIcon from "@/icons/InfoIcon";
import quizOmissionReasons from "@/view/constants/quizOmissionReasons";
import { iconCss, rootCss, textCss } from "./OmittedQuizMessage.style";

const { QUIZ_COMING_SOON, INTENTIONALLY_OMITTED } = quizOmissionReasons;

const propTypes = {
  quizOmissionReason: PropTypes.string,
};

const OmittedQuizMessage = ({ quizOmissionReason }) => {
  if (!quizOmissionReason) {
    return null;
  }

  const messageText = () => {
    if (quizOmissionReason === QUIZ_COMING_SOON) {
      return "This article's quiz isn't published yet. Check again in a couple of days.";
    } else if (quizOmissionReason === INTENTIONALLY_OMITTED) {
      return "This article will remain published without a quiz.";
    }
  };

  return (
    <div css={rootCss}>
      <InfoIcon css={iconCss} />
      <p css={textCss}>{messageText()}</p>
    </div>
  );
};

OmittedQuizMessage.propTypes = propTypes;

export default OmittedQuizMessage;
